{
  "MFA_SETTINGS": {
    "TITLE": "两步验证",
    "SUBTITLE": "Protect your account from unauthorized access with TOTP-based authentication. This adds an extra layer of security to your account.",
    "DESCRIPTION": "使用基于时间的一次性密码(TOTP)为您的帐户添加额外的一层安全保护",
    "STATUS_TITLE": "验证状态",
    "STATUS_DESCRIPTION": "管理您的二步验证设置和备份码",
    "ENABLED": "已启用",
    "DISABLED": "已禁用",
    "STATUS_ENABLED": "两步验证已启用",
    "STATUS_ENABLED_DESC": "您的帐户受到额外的安全层保护",
    "ENABLE_BUTTON": "启用两步验证",
    "ENHANCE_SECURITY": "增强您的帐户安全",
    "ENHANCE_SECURITY_DESC": "两步验证除了您的密码外还需要额外的身份验证程序的验证码，从而增加了额外的安全层次。",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "使用您的身份验证器应用程序扫描二维码",
      "STEP1_DESCRIPTION": "使用 Google 身份验证器、Authy 或者任何 TOTP 兼容应用程序",
      "LOADING_QR": "加载中...",
      "MANUAL_ENTRY": "无法扫描？手动输入代码",
      "SECRET_KEY": "密钥",
      "COPY": "复制",
      "ENTER_CODE": "从您的身份验证程序中输入6位数字代码",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "验证并继续",
      "CANCEL": "取消",
      "ERROR_STARTING": "MFA 未启用。请与管理员联系。",
      "INVALID_CODE": "无效的验证码",
      "SECRET_COPIED": "密钥已复制到剪贴板",
      "SUCCESS": "已成功启用两步验证"
    },
    "BACKUP": {
      "TITLE": "保存您的备份代码",
      "DESCRIPTION": "妥善保管这些备份代码，如果您无法访问身份验证器，每个代码可以使用一次",
      "IMPORTANT": "重要:",
      "IMPORTANT_NOTE": " 将这些代码保存到一个安全的位置。您将无法再次看到它们。",
      "DOWNLOAD": "下载",
      "COPY_ALL": "复制全部",
      "CONFIRM": "我已经将我的备份代码保存在一个安全的位置，并且知道我将无法再次看到它们。",
      "COMPLETE_SETUP": "完成设置",
      "CODES_COPIED": "备份代码已复制到剪贴板"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "备份代码",
      "BACKUP_CODES_DESC": "如果您丢失或使用了您现有的代码，则生成新代码",
      "REGENERATE": "重新生成备份代码",
      "DISABLE_MFA": "禁用两步验证",
      "DISABLE_MFA_DESC": "从您的帐户中删除两步验证",
      "DISABLE_BUTTON": "禁用两步验证"
    },
    "DISABLE": {
      "TITLE": "禁用两步验证",
      "DESCRIPTION": "您需要输入您的密码和验证码来禁用两步验证。",
      "PASSWORD": "密码",
      "OTP_CODE": "验证码",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "备份代码",
      "BACKUP_CODE_PLACEHOLDER": "输入您的备份代码",
      "USE_BACKUP_CODE": "Lost access to your authenticator? Use a backup code instead",
      "USE_OTP_CODE": "Use a verification code from your authenticator app",
      "CONFIRM": "禁用两步验证",
      "CANCEL": "取消",
      "SUCCESS": "两步验证已禁用",
      "ERROR": "禁用MFA失败。请检查您的凭据。"
    },
    "REGENERATE": {
      "TITLE": "重新生成备份代码",
      "DESCRIPTION": "这将作废您现有的备份代码并生成新的替代。输入您的验证码以继续。",
      "OTP_CODE": "验证码",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "生成新代码",
      "CANCEL": "取消",
      "NEW_CODES_TITLE": "新的备份码已生成",
      "NEW_CODES_DESC": "您旧的备份代码已失效。将这些新代码保存到一个安全位置。",
      "CODES_IMPORTANT": "重要:",
      "CODES_IMPORTANT_NOTE": " 每个代码只能使用一次。在关闭此窗口前保存它们。",
      "DOWNLOAD_CODES": "下载代码",
      "COPY_ALL_CODES": "复制全部代码",
      "CODES_SAVED": "我已保存我的代码",
      "SUCCESS": "已生成新的备份代码",
      "ERROR": "重新生成备份代码失败"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "两步验证",
    "DESCRIPTION": "输入您的验证码以继续",
    "AUTHENTICATOR_APP": "身份验证器应用",
    "BACKUP_CODE": "备份代码",
    "ENTER_OTP_CODE": "从您的身份验证程序中输入6位数字代码",
    "ENTER_BACKUP_CODE": "输入您的备份代码",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "验证",
    "TRY_ANOTHER_METHOD": "尝试另一种验证方法",
    "CANCEL_LOGIN": "取消并返回登录",
    "HELP_TEXT": "登录遇到困难吗？",
    "LEARN_MORE": "了解更多关于两步验证的信息",
    "HELP_MODAL": {
      "TITLE": "两步验证帮助",
      "AUTHENTICATOR_TITLE": "使用身份验证器应用程序",
      "AUTHENTICATOR_DESC": "打开你的身份验证器应用（Google Autenticator，Authy等），然后输入应用显示的6位数字",
      "BACKUP_TITLE": "使用备份代码",
      "BACKUP_DESC": "如果您无法访问身份验证器应用程序，你可以使用此前保存的备份代码替代，每个代码只能使用一次。",
      "CONTACT_TITLE": "需要更多帮助吗？",
      "CONTACT_DESC_CLOUD": "如果您无法访问身份验证器应用程序和备份代码，请联系Chatwoot 支持寻求帮助。",
      "CONTACT_DESC_SELF_HOSTED": "如果您无法访问身份验证器应用程序和备份代码，请联系您的管理员寻求帮助。"
    },
    "VERIFICATION_FAILED": "验证失败。请重试。"
  }
}
